import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { Button, TextField } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UpdatePMPlan } from '../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { updatePVPlan } from '../ReduxStore/CreatePlanSlice';
const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(5, 8, 6),
    },
}));

export default function TransitionsModal({ open, handleClose, singlePlan, plan, selectedPlan }) {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showDateModal, setshowDateModal] = useState(false)
    const [formattedDate, setFormattedDate] = useState()
    const [dateLoading, setDateLoading] = useState(false)
    const [resDate, setResDate] = useState();

    useEffect(() => {
        if (singlePlan) {
            const date = singlePlan.start_date;
            const formattedDate = new Date(date).toISOString().split('T')[0] + 'T00:00:00';
            // const [day, month, year] = originalDate.split(' ')[0].split('/');
            // const formattedDate = `${year}-${month}-${day}T00:00:00`;
            setFormattedDate(formattedDate);
        }
    }, [singlePlan]);

    const EditHandler = () => {
        navigate(`/add-plan/${singlePlan.id}/${singlePlan.assetMaster_details.asset_no}`);
    }

    const PMHandler = () => {
        navigate(`/checkpoint-activity/${singlePlan.id}/${singlePlan.asset_id}/${formattedDate}`)
    }

    const rescheduleHandler = () => {
        setshowDateModal(true)
    }

    const formatDate = (date) => {
        const [year, month, day] = date.split("-");
        // Add time to the formatted date
        return `${day}/${month}/${year} 12:00:00`; // Example time: 12:00:00
    };

    const saveDateHandler = async () => {
        setDateLoading(true)
        // const selectedDate = new Date(resDate);
        // selectedDate.setHours(12, 0, 0, 0);

        // Format the date to 'dd/MM/yyyy HH:mm:ss'
        const formattedDate = formatDate(resDate);

        if ('vendor_details' in selectedPlan) {
            console.log("vendor_details")
            const payload = {
                plan_id: selectedPlan.id,
                asset_id: selectedPlan.supplier_id,
                reschedule_date: formattedDate
            }
            try {
                const action = dispatch(updatePVPlan(payload));
                const res = await action.unwrap();
                console.log("resposne in update plan", res)
                if (res.StatusCode === 201) {
                    setshowDateModal(false)
                    handleClose();
                    setDateLoading(false)
                    toast.success("Reschedule Plan Done")
                }
            }
            catch (error) {
                setshowDateModal(false)
                handleClose();
                setDateLoading(false)
                toast.error(error.message || "Something went wrong!");
            }

        } else {
            const payload = {
                plan_id: selectedPlan.id,
                asset_id: selectedPlan.asset_id,
                reschedule_date: formattedDate
            }
            try {
                const action = dispatch(UpdatePMPlan(payload));
                const res = await action.unwrap();
                console.log("resposne in update plan", res)
                if (res.StatusCode === 201) {
                    setshowDateModal(false)
                    handleClose();
                    setDateLoading(false)
                    toast.success("Reschedule Plan Done")
                }
            }
            catch (error) {
                setshowDateModal(false)
                handleClose();
                setDateLoading(false)
                toast.error(error.message || "Something went wrong!");
            }
        }
    }

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    {!showDateModal ? (<div className={classes.paper}>
                        <h3>{singlePlan && singlePlan.description}</h3>
                        <p>Please select an option to continue
                        </p>
                        <Button
                            type="button"
                            variant="contained"
                            fullWidth
                            style={{ backgroundColor: 'gray', color: 'white', marginBottom: "10px" }}
                            onClick={plan === "planoveriew" ? (EditHandler) : (handleClose)}
                        >
                            {plan === "planoveriew" ? "Edit Plan" : "Cancel"}
                        </Button>
                        <Button
                            type="button"
                            variant="contained"
                            fullWidth
                            color="primary"
                            onClick={plan === "planoveriew" ? (PMHandler) : (rescheduleHandler)}
                        >
                            {plan === "planoveriew" ? "PM Activity" : "Reschedule Plan"}
                        </Button>
                    </div>) :
                        (<div className={classes.paper}>
                            <h3>Enter new Date for {singlePlan && singlePlan.assetMaster_details.asset_text}</h3>
                            <TextField
                                label="Start Date"
                                name="startDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                onChange={(e) => setResDate(e.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            <Button
                                type="button"
                                variant="contained"
                                fullWidth
                                color="primary"
                                onClick={saveDateHandler}
                                style={{ marginTop: "10px" }}
                            >
                                {dateLoading ? "Saving..." : "Save"}
                            </Button>
                        </div>)}
                </Fade>
            </Modal>
            <ToastContainer />
        </div>
    );
}
